import React from "react";
import styled from "styled-components";
import { FaRegCopyright } from "react-icons/fa";

const FooterStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 20px;
  padding-top: 10px;
  border-top: 1px solid var(--text-primary-color);

  @media only screen and (max-width: 560px) {
    padding-right: 10px;
    padding-left: 10px;
    font-size: 10px;
  }
`;

function Footer() {
  return (
    <FooterStyled>
      <FaRegCopyright />
      copyright 2022| EKWEALOR HILLARY | All right reserved
    </FooterStyled>
  );
}

export default Footer;
